"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./consts'),
    defaultReservedParamNames = _require.reservedParamNames,
    dataFixerParamNames = _require.dataFixerParamNames,
    mandatoryPageModuleRequestParams = _require.mandatoryPageModuleRequestParams;

var _require2 = require('./errors'),
    ReservedParameterError = _require2.ReservedParameterError;

var _require3 = require('./kendash'),
    notEmpty = _require3.notEmpty;

var paramNames = function paramNames(arr) {
  return arr ? Object.keys(arr) : [];
};

var makeModuleValidator = require('./moduleValidtor');

var makeVersionValidator = require('./versionValidator');

var makePageValidator = require('./pageValidtor');

var makeRevisionValidator = require('./revisionValidtor');

var makeIdValidator = require('./idValidtor');

var makeContentTypeValidator = require('./contentTypeValidator');

var makeCommonConfigValidator = require('./commonConfigValidator');

var makeMandatoryParamsValidator = require('./mandatoryParamsValidator');

var pageMandatoryParamsValidator = makeMandatoryParamsValidator(mandatoryPageModuleRequestParams); // todo refactor: validationCheckMessage should get the params and build the whole message (extract message building to a collaborator)

module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$additionalReserv = _ref.additionalReservedParams,
      additionalReservedParams = _ref$additionalReserv === void 0 ? [] : _ref$additionalReserv,
      _ref$moduleList = _ref.moduleList,
      moduleList = _ref$moduleList === void 0 ? [] : _ref$moduleList;

  var versionValidator = makeVersionValidator();
  var siteRevisionValidator = makeRevisionValidator();
  var pageValidator = makePageValidator();
  var siteIdValidator = makeIdValidator();
  var contentTypeValidator = makeContentTypeValidator();
  var moduleValidator = makeModuleValidator(moduleList);
  var commonConfigValidator = makeCommonConfigValidator(siteRevisionValidator, siteIdValidator);
  /**
   * validate that custom module params must not contain reserved param names
   */

  var customParamsValidation = {
    predicate: function predicate(param) {
      return [].concat(_toConsumableArray(additionalReservedParams), _toConsumableArray(defaultReservedParamNames)).includes(param);
    },
    validationCheckMessage: 'reserved param'
  };
  /**
   * validate that data fixer params must only contain allowed data fixer param names
   */

  var dataFixerParamsValidation = {
    predicate: function predicate(param) {
      return !dataFixerParamNames.includes(param);
    },
    validationCheckMessage: 'not data fixer param'
  };

  var validateReservedParams = function validateReservedParams(params, validation) {
    var invalidParams = paramNames(params).filter(validation.predicate);

    if (notEmpty(invalidParams)) {
      throw new ReservedParameterError(validation.validationCheckMessage, invalidParams);
    }
  };

  return {
    validateCustomParams: function validateCustomParams(params) {
      return validateReservedParams(params, customParamsValidation);
    },
    validateDataFixerParams: function validateDataFixerParams(params) {
      return validateReservedParams(params, dataFixerParamsValidation);
    },
    validateMandatoryPageModuleParams: function validateMandatoryPageModuleParams(params) {
      return pageMandatoryParamsValidator.validate(params);
    },
    validateModule: function validateModule(module) {
      return moduleValidator.validate(module);
    },
    validateVersion: function validateVersion(version) {
      return versionValidator.validate(version);
    },
    validateSiteId: function validateSiteId(id) {
      return siteIdValidator.validate(id);
    },
    validateSiteRevision: function validateSiteRevision(revision) {
      return siteRevisionValidator.validate(revision);
    },
    validatePage: function validatePage(page) {
      return pageValidator.validate(page);
    },
    validateContentType: function validateContentType(contentType) {
      return contentTypeValidator.validate(contentType);
    },
    validateCommonConfig: function validateCommonConfig(commonConfig) {
      return commonConfigValidator.validate(commonConfig);
    }
  };
};
//# sourceMappingURL=validator.js.map